import { render, staticRenderFns } from "./PracticesList.vue?vue&type=template&id=2cb2c0dc&scoped=true&"
import script from "./PracticesList.vue?vue&type=script&lang=js&"
export * from "./PracticesList.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PracticesList.vue?vue&type=style&index=1&id=2cb2c0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2c0dc",
  null
  
)

export default component.exports